export const USER_PROFILE = 'USER_PROFILE';
export const UPDATE_ASYNC_START = 'UPDATE_ASYNC_START';
export const FECH_MERCHANT_BANKS = 'FECH_MERCHANT_BANKS';
export const FECH_MERCHANT_BANKS_SUCESS = 'FECH_MERCHANT_BANKS_SUCESS';
export const FECH_MERCHANT_BANKS_FAILED = 'FECH_MERCHANT_BANKS_FAILED';
export const FECH_SETTLEMENT_TIMES = 'FECH_SETTLEMENT_TIMES';
export const FECH_SETTLEMENT_TIMES_SUCESS = 'FECH_SETTLEMENT_TIMES_SUCESS';
export const FECH_SETTLEMENT_TIMES_FAILED = 'FECH_SETTLEMENT_TIMES_FAILED';

export const UPDATE_PRIMARY_ACCOUNT = 'UPDATE_PRIMARY_ACCOUNT';
export const UPDATE_PRIMARY_ACCOUNT_SUCCESS = 'UPDATE_PRIMARY_ACCOUNT_SUCCESS';
export const UPDATE_PRIMARY_ACCOUNT_FAILED = 'UPDATE_PRIMARY_ACCOUNT_FAILED';

export const DELETE_ACCOUNT = 'DELETE_ACCOUNT';
export const DELETE_ACCOUNT_SUCCESS = 'DELETE_ACCOUNT_SUCCESS';
export const DELETE_ACCOUNT_FAILED = 'DELETE_ACCOUNT_FAILED';

export const FETCH_BANK_DETAILS = 'FETCH_BANK_DETAILS';
